import React from 'react'
import { Helmet } from 'react-helmet'
import { PageContentShell, PageViewport } from '../../components/PageLayout'
import { getTopbarHeight, useDimensions } from '../../hooks/useDimensions'
import { AppBarComponent } from '../AppBar'
import { FooterBarComponent } from '../FooterBar'
import { ErrorPageDescription, ErrorPagePanel, ErrorPageTitle } from './styled'

export const ErrorPage: React.FC = () => {
  const { height, width } = useDimensions()
  const topbarHeight = getTopbarHeight(width)

  return (
    <>
      <Helmet>
        <title>Page Not Found || JustLockIt</title>
      </Helmet>
      <AppBarComponent />
      <PageViewport className="error-page" viewportHeight={height}>
        <PageContentShell
          className="error-page__shell"
          topbarHeight={topbarHeight}
        >
          <ErrorPagePanel className="error-page__panel">
            <ErrorPageTitle className="error-page__title" variant="h3">
              Page not found
            </ErrorPageTitle>
            <ErrorPageDescription
              className="error-page__description"
              variant="body1"
            >
              The page you requested does not exist or has been moved.
            </ErrorPageDescription>
          </ErrorPagePanel>
        </PageContentShell>
      </PageViewport>
      <FooterBarComponent />
    </>
  )
}
